export default "__VITE_PUBLIC_ASSET__f01aa2ab__"